export enum GivingScopeEnum {
  BROWSE = 'browse',
  NOW = 'now',
}
